import $ from 'jquery';

// map accessibility
$('.dealersite-map').each(function () {
  $(this).find('iframe').attr('title', 'map').attr('aria-label', 'map').attr('role', 'region');
  $(this)
    .find('iframe')
    .find('img')
    .attr('title', 'map')
    .attr('aria-label', 'map')
    .attr('role', 'region');
});

$('.vlp-pagination').each(function () {
  $(this)
    .find('.page-numbers')
    .each(function () {
      const pageNum = parseInt($(this).text());

      $(this)
        .attr('title', 'Page ' + pageNum)
        .attr('aria-label', 'Page ' + pageNum)
        .attr('role', 'button');
    });
  $(this)
    .find('.prev')
    .attr('title', 'Previous Page')
    .attr('aria-label', 'Previous Page')
    .text('')
    .addClass('w-20');
  $(this)
    .find('.next')
    .attr('title', 'Next Page')
    .attr('aria-label', 'Next Page')
    .text('')
    .addClass('w-16');
});

$('.flp-nav').each(function () {
  $(this).attr('role', 'menu');
});
